import React from "react";

const DraggingIcon = (props) => {
  return (
    <svg
      width="43"
      height="41"
      viewBox="0 0 43 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_8631_8436)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5 7.76465C19.8431 7.76465 18.5 9.10779 18.5 10.7646V17.8647C16.2178 18.3279 14.5 20.3457 14.5 22.7646V25.8419C14.5 27.3008 14.9559 28.7233 15.8039 29.9105L18.7889 34.0896C19.5398 35.1408 20.752 35.7646 22.0439 35.7646H29.759C31.1945 35.7646 32.5198 34.9955 33.232 33.7492L35.5777 29.6442C36.1821 28.5866 36.5 27.3895 36.5 26.1713V22.7646C36.5 20.0841 34.3906 17.8962 31.7412 17.7704C31.1917 17.1533 30.3913 16.7646 29.5 16.7646C28.9653 16.7646 28.4634 16.9045 28.0286 17.1496C27.4956 16.3167 26.5623 15.7646 25.5 15.7646C25.1494 15.7646 24.8128 15.8248 24.5 15.9354V10.7646C24.5 9.10779 23.1569 7.76465 21.5 7.76465Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 7.76465C19.8431 7.76465 18.5 9.10779 18.5 10.7646V17.8647C16.2178 18.3279 14.5 20.3457 14.5 22.7646V25.8419C14.5 27.3008 14.9559 28.7233 15.8039 29.9105L18.7889 34.0896C19.5398 35.1408 20.752 35.7646 22.0439 35.7646H29.759C31.1945 35.7646 32.5198 34.9955 33.232 33.7492L35.5777 29.6442C36.1821 28.5866 36.5 27.3895 36.5 26.1713V22.7646C36.5 20.0841 34.3906 17.8962 31.7412 17.7704C31.1917 17.1533 30.3913 16.7646 29.5 16.7646C28.9653 16.7646 28.4634 16.9045 28.0286 17.1496C27.4956 16.3167 26.5623 15.7646 25.5 15.7646C25.1494 15.7646 24.8128 15.8248 24.5 15.9354V10.7646C24.5 9.10779 23.1569 7.76465 21.5 7.76465ZM24.5 18.7646C24.5 19.3169 24.0523 19.7646 23.5 19.7646C22.9477 19.7646 22.5 19.3169 22.5 18.7646V10.7646C22.5 10.2124 22.0523 9.76465 21.5 9.76465C20.9477 9.76465 20.5 10.2124 20.5 10.7646V23.7646C20.5 24.3169 20.0523 24.7646 19.5 24.7646C18.9477 24.7646 18.5 24.3169 18.5 23.7646V19.9354C17.3348 20.3472 16.5 21.4584 16.5 22.7646V25.8419C16.5 26.884 16.8256 27.9 17.4313 28.7481L20.4164 32.9271C20.7918 33.4527 21.398 33.7646 22.0439 33.7646H29.759C30.4767 33.7646 31.1394 33.3801 31.4955 32.7569L33.8412 28.652C34.2729 27.8965 34.5 27.0414 34.5 26.1713V22.7646C34.5 21.4584 33.6652 20.3472 32.5 19.9354V20.7646C32.5 21.3169 32.0523 21.7646 31.5 21.7646C30.9477 21.7646 30.5 21.3169 30.5 20.7646V19.7646C30.5 19.2124 30.0523 18.7646 29.5 18.7646C28.9477 18.7646 28.5 19.2124 28.5 19.7646C28.5 20.3169 28.0523 20.7646 27.5 20.7646C26.9477 20.7646 26.5 20.3169 26.5 19.7646V18.7646C26.5 18.2124 26.0523 17.7646 25.5 17.7646C24.9477 17.7646 24.5 18.2124 24.5 18.7646Z"
        fill="#12131A"
      />
      <g filter="url(#filter1_d_8631_8436)">
        <path
          d="M33.1563 5.90903C33.1563 5.32438 33.8631 5.03158 34.2765 5.44499L38.8676 10.036C39.1239 10.2923 39.1239 10.7078 38.8676 10.9641L34.2765 15.5551C33.8631 15.9685 33.1563 15.6757 33.1563 15.091V12.4688H27.9063C26.8189 12.4688 25.9375 11.5873 25.9375 10.5C25.9375 9.41273 26.8189 8.53129 27.9063 8.53129H33.1563V5.90903Z"
          fill="#12131A"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.4688 9.84379H27.9063C27.5438 9.84379 27.25 10.1376 27.25 10.5C27.25 10.8625 27.5438 11.1563 27.9063 11.1563H34.4688V13.5067L37.4755 10.5L34.4688 7.49334V9.84379ZM33.1563 5.90903C33.1563 5.32438 33.8631 5.03158 34.2765 5.44499L38.8676 10.036C39.1239 10.2923 39.1239 10.7078 38.8676 10.9641L34.2765 15.5551C33.8631 15.9685 33.1563 15.6757 33.1563 15.091V12.4688H27.9063C26.8189 12.4688 25.9375 11.5873 25.9375 10.5C25.9375 9.41273 26.8189 8.53129 27.9063 8.53129H33.1563V5.90903Z"
        fill="white"
      />
      <g filter="url(#filter2_d_8631_8436)">
        <path
          d="M9.84305 5.90903C9.84305 5.32438 9.13618 5.03158 8.72277 5.44499L4.13167 10.036C3.87538 10.2923 3.87538 10.7078 4.13167 10.9641L8.72277 15.5551C9.13618 15.9685 9.84305 15.6757 9.84305 15.091V12.4688H15.0931C16.1804 12.4688 17.0618 11.5873 17.0618 10.5C17.0618 9.41273 16.1804 8.53129 15.0931 8.53129H9.84305V5.90903Z"
          fill="#12131A"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53055 9.84379H15.0931C15.4555 9.84379 15.7493 10.1376 15.7493 10.5C15.7493 10.8625 15.4555 11.1563 15.0931 11.1563H8.53055V13.5067L5.52379 10.5L8.53055 7.49334V9.84379ZM9.84305 5.90903C9.84305 5.32438 9.13618 5.03158 8.72277 5.44499L4.13167 10.036C3.87538 10.2923 3.87538 10.7078 4.13167 10.9641L8.72277 15.5551C9.13618 15.9685 9.84305 15.6757 9.84305 15.091V12.4688H15.0931C16.1804 12.4688 17.0618 11.5873 17.0618 10.5C17.0618 9.41273 16.1804 8.53129 15.0931 8.53129H9.84305V5.90903Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_8631_8436"
          x="11.5"
          y="6.26465"
          width="28"
          height="34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.5" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8631_8436"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8631_8436"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_8631_8436"
          x="24.5202"
          y="4.54282"
          width="15.9576"
          height="13.3316"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.708641" />
          <feGaussianBlur stdDeviation="0.708641" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8631_8436"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8631_8436"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_8631_8436"
          x="2.52217"
          y="4.54282"
          width="15.9576"
          height="13.3316"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.708641" />
          <feGaussianBlur stdDeviation="0.708641" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8631_8436"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8631_8436"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default DraggingIcon;
